"use strict";
var index_1 = require("./lib/index");
exports.SwiperComponent = index_1.SwiperComponent;
exports.SwiperDirective = index_1.SwiperDirective;
exports.coverflowObject = index_1.coverflowObject;
exports.cubeObject = index_1.cubeObject;
exports.fadeObject = index_1.fadeObject;
exports.flipObject = index_1.flipObject;
exports.SwiperConfig = index_1.SwiperConfig;
exports.SwiperEvents = index_1.SwiperEvents;
exports.provideDefaultConfig = index_1.provideDefaultConfig;
exports.provideForRootGuard = index_1.provideForRootGuard;
exports.SWIPER_CONFIG = index_1.SWIPER_CONFIG;
exports.SWIPER_GUARD = index_1.SWIPER_GUARD;
exports.SwiperModule = index_1.SwiperModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-swiper-wrapper/dist/index.js
// module id = 294
// module chunks = 4